import React from 'react';
import UiContent from '../../../Components/Common/UiContent';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import { Container } from 'reactstrap';
import FuelTypeList from './FuelTypeList';

//redux

const FuelType = () => {
	const breadcrumbLinks = [
		{ to: '#', label: 'Inicio', icon: 'icon-house' },
		{ to: '#', label: 'Abastecimiento', icon: 'icon-shopping-basket' },
		{ to: '#', label: 'Combustible', icon: 'icon-fuel' },
		{ to: '#', label: 'Configuración', icon: 'icon-settings' }
	];

	return (
		<React.Fragment>
			<UiContent />
			<div className='page-content'>
				<Container fluid>
					<BreadCrumb title='Tipo Combustible' links={breadcrumbLinks} icon={'icon-layout-list'} />
					<FuelTypeList />
				</Container>
			</div>
		</React.Fragment>
	);
};

export default FuelType;
